import { useAuth as useAuthOwnerBypass } from "@/contexts/AuthContext";
import { usePermissions } from "@/contexts/PermissionsContext";
import { ShieldAlert } from "lucide-react";

/**
 * Guard de rota por permissão RBAC.
 * Usage: <Route path="usuarios" element={<RequirePermission permission="usuarios.view"><Usuarios /></RequirePermission>} />
 */
function RequirePermissionBase({ permission, children, fallback }) {
  const { hasPermission, loading } = usePermissions();

  if (loading) {
    return (
      <div className="flex items-center justify-center h-64" data-testid="perm-loading">
        <div className="animate-pulse text-xs uppercase tracking-widest text-muted-foreground">
          Carregando permissões…
        </div>
      </div>
    );
  }

  if (!hasPermission(permission)) {
    if (fallback) return fallback;
    return (
      <div className="max-w-md mx-auto mt-16 text-center space-y-4" data-testid="perm-denied">
        <div className="inline-flex items-center justify-center h-14 w-14 rounded-full border border-critical/30 bg-critical/5 text-critical">
          <ShieldAlert className="h-6 w-6" />
        </div>
        <div>
          <h2 className="font-display text-2xl font-medium">Sem acesso a este módulo</h2>
          <p className="mt-2 text-sm text-muted-foreground">
            Você não tem a permissão necessária <code className="px-1.5 py-0.5 rounded bg-accent text-[11px] font-mono">{permission}</code> para
            visualizar este conteúdo. Fale com um administrador do escritório.
          </p>
        </div>
      </div>
    );
  }

  return children;
}


// platform_owner nunca fica bloqueado por permissão de módulo (evita "Sem acesso" ao recarregar)
export function RequirePermission(props) {
  const auth = useAuthOwnerBypass() || {};
  if (auth.user?.role === "platform_owner") return props.children;
  return <RequirePermissionBase {...props} />;
}
